import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";

const offset = 800;
const isQuickLoad = window.sidedEmbed && window.sidedEmbed.quickLoad;
const isObserved = window.sidedEmbed && window.sidedEmbed.isObserved;
const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en: {},
  },
});

function mountApp(element) {
  const app = createApp(App);
  app.config.unwrapInjectedRef = true;
  app.use(i18n);
  app.mount(element);
}

window.InitSidedEmbeds = () => {
  const elements = document.querySelectorAll(".sided-widget:not([data-v-app])");
  elements.forEach(function (element) {
    if (
      element.offsetTop - offset < window.scrollY + window.innerHeight ||
      isQuickLoad
    ) {
      mountApp(element);
    }
  });
};

window.destroySidedEmbeds = () => {
  // document.querySelectorAll('.sided-widget').forEach(function(element){
  // 	element.remove();
  // })
};

window.InitSidedEmbedAds = () => {
  const elements = document.querySelectorAll(".sided-widget:not(.has-ad)");
  elements.forEach(function (element) {
    const parentNode = element.parentNode;

    const dskDiv = document.createElement("div");
    dskDiv.setAttribute("id", "dsk-sided-ad-a");

    const mobDiv = document.createElement("div");
    mobDiv.setAttribute("id", "mob-sided-ad-a");

    element.classList.add("has-ad");
    parentNode.insertBefore(dskDiv, element);
    parentNode.insertBefore(mobDiv, element);

    window.dispatchEvent(
      new CustomEvent("sided:init", {
        detail: parentNode,
      }),
    );
  });
};

//window.addEventListener('load', window.InitSidedEmbedAds)

if (window.location.host === "sportspyder.com") {
  window.addEventListener("scroll", () => {
    window.InitSidedEmbeds();
  });
}

if (window.sidedEmbed && window.sidedEmbed.preventInit) {
  // prevent auto init
} else {
  window.addEventListener("DOMContentLoaded", window.InitSidedEmbeds);
  window.addEventListener("load", () => window.InitSidedEmbeds());

  if (!isQuickLoad && !isObserved) {
    window.addEventListener("scroll", window.InitSidedEmbeds);
  }

  if (isObserved) {
    // window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(".sided-widget").forEach(function (element) {
      const observer = new IntersectionObserver(
        function () {
          if (
            !element.hasAttribute("data-v-app") &&
            element.offsetTop - offset < window.scrollY + window.innerHeight
          ) {
            mountApp(element);
          }
        },
        {
          rootMargin: `${offset}px`,
        },
      );

      observer.observe(element);
    });
    // })
  }
}
